import React, { useEffect, useState } from 'react';
import s from './styles.module.scss';
import { IPromotionalApp } from '@/infrastructure/interfaces/i-promotional-app';
import { PromotionalApp } from '@/infrastructure/class/promotional-app';
import { isIOS, isMacOs } from 'react-device-detect';
import OurAppsListItem from './item';

interface IOurAppListProps {
  items: IPromotionalApp[];
  className?: string;
}

const OurAppList: React.FC<IOurAppListProps> = (props) => {
  const { items, className = '' } = props;
  const [promotionalApps, setPromotionalApps] = useState<PromotionalApp[]>([]);

  useEffect(() => {
    const apps = items
      .map((promotionalApp) => new PromotionalApp(promotionalApp))
      .filter((promotionalApp) => {
        if (isIOS || (isMacOs && promotionalApp.link_ios.length)) return true;
        else if (promotionalApp.link_android) return true;
        return false;
      });
    setPromotionalApps(apps);
  }, [items]);

  return (
    <ul className={s['list']}>
      {promotionalApps.map((promotionalApp) => (
        <OurAppsListItem
          key={promotionalApp.id}
          className={s['']}
          data={promotionalApp}
        />
      ))}
    </ul>
  );
};

export default OurAppList;
